import { render, staticRenderFns } from "./DenyCreativeForm.vue?vue&type=template&id=b3060ac2&scoped=true&"
import script from "./DenyCreativeForm.vue?vue&type=script&lang=js&"
export * from "./DenyCreativeForm.vue?vue&type=script&lang=js&"
import style0 from "./DenyCreativeForm.vue?vue&type=style&index=0&id=b3060ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3060ac2",
  null
  
)

export default component.exports